const mutations = {
    setUnread(state,payload) {
        state.unread = payload
    },
    updateChatUnreadStatus(state, { chatId, unread }) {
        const chatIndex = state.chats.findIndex(chat => chat.id === chatId);
        if (chatIndex !== -1) {
            state.chats[chatIndex].unread = unread;
        }
    },
    updateChat(state, updatedChat) {
        const chatIndex = state.chats.findIndex(chat => chat.id === updatedChat.id);
        if (chatIndex !== -1) {
            state.chats.splice(chatIndex, 1, updatedChat);
        }
    }
}

export default mutations